export const AUDIT_RULE_CATEGORY_LABELS = {
  kardex: 'Kardex y traspasos',
  inventory: 'Toma de inventario',
};

export function getAuditNotificationProductLabel(notification) {
  if (!notification) return null;
  return (
    notification.product_name
    || notification.data?.product_name
    || null
  );
}

export function formatAuditNotificationMessage(notification, fallback = 'Alerta de auditoría') {
  const productName = getAuditNotificationProductLabel(notification);
  const message = notification?.message || notification?.data?.message || fallback;
  if (!productName) return message;
  return `${productName} — ${message}`;
}

export function getAuditEventProductLabel(event) {
  if (event?.product?.name) {
    return event.product.name;
  }
  if (event?.payload?.product_name) {
    return event.payload.product_name;
  }
  if (event?.product_id) {
    return `Producto #${event.product_id}`;
  }
  return '—';
}

export function auditRuleLabel(code, fallback = code) {
  const labels = {
    salida_costo_incorrecto: 'Costo salida incorrecto',
    linea_total_inconsistente: 'Línea total inconsistente',
    stock_negativo: 'Stock negativo',
    valor_negativo: 'Valor negativo',
    salida_vaciado_stock: 'Stock cero con valor residual',
    recepcion_costo_traspaso: 'Recepción vs traspaso',
    entrada_costo_cero: 'Entrada con costo cero',
    costo_temporal_aplicado: 'Costo temporal aplicado',
    costo_temporal_sin_referencia: 'Costo temporal sin referencia',
    costo_temporal_heredado_traspaso: 'Costo temporal heredado (traspaso)',
    recepcion_excede_pendiente: 'Recepción excede pendiente',
    traspaso_incompleto: 'Traspaso incompleto',
    traspaso_sin_recepcion: 'Traspaso sin recepción',
    traspaso_pendiente_dado_por_perdido: 'Pendiente dado por perdido',
    inventario_meta_pendiente: 'Meta de inventario pendiente',
    inventario_vencido: 'Campaña vencida',
    inventario_producto_pendiente_compra: 'Producto pendiente (compra)',
    inventario_rotacion_vencida: 'Rotación de inventario vencida',
  };
  return labels[code] || fallback;
}
